export const diagnosticDemoRegions = {
  items: [
    {
      type: 'slider_element',
    },
  ],

  'bottom-right': [{ type: 'next_button' }],
};
